import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
  @Input() buttonText: string = '';
  @Input() buttonIcon: any;
  @Input() buttonType: string = '';
  @Input() buttonColor: string = '';
  @Input() buttonLink: string = '';

  buttonClasses: any = [];
  openModal: boolean = false;

  constructor(private router: Router) {}

  ngOnInit() {
    this.buttonClasses.push(this.buttonType);
    this.buttonClasses.push(this.buttonColor);
  }

  handleButtonClick() {
    if (this.buttonLink === 'outbound') {
      window.open('https://medigiswag.com/', '_blank');
    } else if (this.buttonLink === 'do-nothing' || this.buttonLink === '') {
      return;
    } else {
      this.router.navigate([this.buttonLink]);
    }
  }
}
